import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import accountReducer from './accountReducer';
import notificationsReducer from './notificationsReducer';
import kanbanReducer from './kanbanReducer';
import historyNavigationReducer from './historyNavigationReducer';
import productionOrderReducer from './productionOrderReducer';

const rootReducer = combineReducers({
  account: accountReducer,
  notifications: notificationsReducer,
  kanban: kanbanReducer,
  form: formReducer,
  historyNavigation: historyNavigationReducer,
  productionOrder: productionOrderReducer,
});

export default rootReducer;
